import { ChartOptionsProps } from "../../CommonInterfaceForChartOptions";

export const useChartLegend = ({
  chartControls,
  tabTileProps,
  chartProperties,
}: ChartOptionsProps) => {
  const propKey = `${tabTileProps.selectedTabId}.${tabTileProps.selectedTileId}`;
  
  const showLegend: boolean =
    chartControls.properties[propKey].legendOptions.showLegend;

  const orientation: string =
    chartProperties.properties[propKey].chartType === "calendar" ||
    chartProperties.properties[propKey].chartType === "heatmap"
      ? chartControls.properties[propKey].calendarStyleOptions.orientation
      : chartControls.properties[propKey].legendOptions.orientation;

  const isCalendarOrHeatmap = 
    chartProperties.properties[propKey].chartType === "calendar" ||
    chartProperties.properties[propKey].chartType === "heatmap";

  return {
    propKey,
    showLegend,
    orientation,
    isCalendarOrHeatmap,
  };
};